import AnimeUtils from '../common/utils/anime.es6';
import ConvertUtils from '../common/utils/convert.es6';
import ObjUtils from '../common/utils/obj.es6';
import Swiper from 'swiper/bundle';
import 'swiper/css';

const MAIN_WIDTH = 780;
const BNR_WIDTH = 520;
const NUM_ALLOWED_LOOP = 3;

function applyStackBaseStyles(swiper) {
    const el = swiper?.el;
    const wrapperEl = swiper?.wrapperEl;
    if (!el || !wrapperEl) return;

    const overflowVisibleKeys = new Set(['mainKv', 'bnr']);
    const sliderKey = el?.dataset?.key;

    el.style.perspective = '1200px';
    el.style.transformStyle = 'preserve-3d';
    wrapperEl.style.transformStyle = 'preserve-3d';

    el.style.overflow = overflowVisibleKeys.has(sliderKey) ? 'visible' : 'hidden';

    swiper.slides?.forEach((slide) => {
        slide.style.backfaceVisibility = 'hidden';
        slide.style.transformStyle = 'preserve-3d';
    });
}

export default class Slider {
    constructor() {
        this.swipers = {};

        this._setSlider();
    }

    _setSlider() {
        const $sliders = [...document.querySelectorAll('.js-slider')];
        let prevIndex = 0;

        const commonParams = {
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                waitForTransition: false,
            },
            centeredSlides: true,
            pagination: {
                bulletActiveClass: '-active',
                bulletClass: 'c-hover_op',
                bulletElement: 'button',
                clickable: true,
                el: '.js-slider_pagination',
            },
            slideActiveClass: '-active',
            slideClass: 'js-slider_slide',
            wrapperClass: 'js-slider_wrapper',
        };

        const addParams = {
            subKv: {
                pagination: false,
                slidesPerView: 'auto',
                speed: 800,
                on: {
                    init(swiper) {
                        swiper.slideToLoop(0, 0);
                    },
                },
            },
            mainKv: {
                effect: 'creative',
                loopAdditionalSlides: 1,
                pagination: false,
                slidesPerView: 'auto',
                speed: 400,
                watchSlidesProgress: true,
                creativeEffect: {
                    limitProgress: 1,
                    prev: {
                        translate: [-220, 0, 0],
                        rotate: [0, 0, 0],
                        opacity: 0,
                        scale: 1,
                    },
                    next: {
                        translate: [0, 0, -40],
                        rotate: [0, 0, -8],
                        opacity: 0,
                        scale: 0.8,
                    },
                },
                on: {
                    init(swiper) {
                        swiper.slideToLoop(0, 0);
                    },
                },
            },
        };

        for (const $slider of $sliders) {
            const $wrapper = $slider.querySelector('.js-slider_wrapper');
            const $slides = [...$wrapper.querySelectorAll('.js-slider_slide')];
            const { key } = $slider.dataset;

            if (key === 'bnr') continue;

            addParams[key].loop = $slides.length >= NUM_ALLOWED_LOOP;

            const params = ObjUtils.deepMerge(commonParams, addParams[key]);

            params.navigation = {
                nextEl: $slider.querySelector('.js-slider_nextBtn'),
                prevEl: $slider.querySelector('.js-slider_prevBtn'),
            };

            this.swipers[key] = new Swiper($slider, params);
            this.swipers[key].count = $slides.length;
        }
    }
}
